<!--begin::List-->
<div class="list list-hover">
    <!--begin::Item-->
    <div *ngFor="let item of favorites" style="cursor: pointer;" (click)="openMicroApp(item)" class="list-item hoverable p-2 p-lg-2 mb-2">
      <div class="d-flex align-items-center" #favorite>
        <!--begin::Symbol-->
        <div class="symbol symbol-40 symbol-light mr-4">
          <span class="symbol-label bg-hover-white">
            <span
              
              cacheSVG="true"
              class="svg-icon h-50 align-self-center"
            ></span>
          </span>
        </div>
        <!--end::Symbol-->
        <!--begin::Text-->
        <div class="d-flex flex-column flex-grow-1 mr-2">
          <span class="text-dark-75 font-size-h6 mb-0">{{item.text}}</span>
          <!-- <a  class="text-muted text-hover-primary font-weight-bold"
            >Favorito</a> -->
        </div>
        <!--begin::End-->
        <dx-context-menu [dataSource]="[{ text: 'Eliminar favorito', icon: 'remove', action: 'remove', id: item.fav_maid }]" [width]="200" [target]="favorite" (onItemClick)="itemClick($event)" >              
      </dx-context-menu>
      </div>
    </div>